import styled from 'styled-components';
import { theme } from '../../../styles/theme';
import {
  floatingComponentStyles,
  overflowingStyles,
} from '../../../styles/shareableStyles';

export const Container = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 16px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  // since width of scratchpad is expandable
  // we need to subtract the width of the actions container
  max-width: calc(100% - 84px);
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.secondary900};
  height: 20px;
  line-height: 20px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
`;

export const SelectMenuContainer = styled.div`
  position: relative;
  cursor: pointer;
`;

export const Menu = styled.div`
  width: 220px;
  ${floatingComponentStyles};
`;

export const TruncatedText = styled.div`
  max-width: 100%;
  ${overflowingStyles};
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

export const SharedTitle = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
  margin: 8px;
`;
